<template>
  <div class="animated fadeIn upload-prk">
    <b-row align-h="center">
      <b-col md="10">
        <b-card>
          <div slot="header">
            {{ this.$route.meta.title }}
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>
          <b-card class="ColsDefine">
            <b-input-group>
              <b-input-group-prepend>
                <label>Periode Trx.</label>
              </b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" :state="!$v.tblData.tgl1.$error" type="date"></b-form-input>
              <b-input-group-prepend
                ><span class="input-group-text"
                  >until</span
                ></b-input-group-prepend
              >
              <b-form-input v-model="tblData.tgl2" :state="!$v.tblData.tgl2.$error" type="date"></b-form-input>
            </b-input-group>
          </b-card>

          <div slot="footer" class="text-center">
            <b-button
              variant="primary"
              @click="confirmReprocess = true"
              class="mr-1"
              ><i class="fa fa-refresh"></i> Reprocess</b-button
            >
            <b-button variant="danger" @click="close()">Cancel</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Konfirmasi"
      v-model="confirmReprocess"
      @ok="reprocessData"
    >
      <div class="my-2 text-center">
        <p>Anda akan memproses data ini.</p>
        <p>Apakah anda yakin?</p>
      </div>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
  
<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }

  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import disbursement from "../../apis/disbursement";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    tblData: {
      tgl1: { required },
      tgl2: { required },
    },
  },
  data() {
    return {
      showUploadFrm: true,
      confirmReprocess: false,
      saveEnabled: true,
      isLoading: false,
      tblData: {
        tgl1: "",
        tgl2: "",
      },
    };
  },
  components: { Loading },
  computed: {
    invalidTblData() {
      this.$v.tblData.$touch();
      return this.$v.tblData.$invalid;
    },
  },
  watch: {
    rptLines(value) {
      this.calcsum(value);
    },
  },
  created: async function () {},
  methods: {
    async reprocessData() {
      if (this.invalidTblData) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.isLoading = true;
          this.saveEnabled = false;
          await disbursement.reprocessDataUpload(this.tblData);
          toastr.success("Reprocess Data Berhasil");
          // router.push({ name: "loan.agunanlist", params: { keys } });
          this.isLoading = false;
          this.saveEnabled = true;
          // this.showUploadFrm = true;
        } catch (error) {
          this.saveEnabled = true;
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      try {
        router.push({ name: "upload.disbursement" });
      } catch (error) {}
    },
    cancel() {
      try {
        router.push({ name: "upload.disbursement" });
      } catch (error) {}
    },
  },
};
</script>
  